import { Suspense, lazy } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import './App.css';
import GlobalAlertProvider from './components/GlobalAlertProvider';

import { ToastProvider } from './components/ToastContext';
import ProtectedRoute from './lib/ProtectedRoute';
import JoinServiceGate from './pages/JoinServiceGate';

const DispatchTerm = lazy(() => import('./pages/DispatchTerm'));
const Faq = lazy(() => import('./pages/Faq'));
const Home = lazy(() => import('./pages/Home'));
const Info = lazy(() => import('./pages/Info'));
const InfoEdit = lazy(() => import('./pages/InfoEdit'));
const InsuranceApply = lazy(() => import('./pages/InsuranceApply'));
const InsuranceHistory = lazy(() => import('./pages/InsuranceHistory'));
const InsuranceTerm = lazy(() => import('./pages/InsuranceTerm'));
const NotFound = lazy(() => import('./pages/NotFound'));

function App() {
  return (
    <Router>
      <GlobalAlertProvider>
        <ToastProvider>
          <Suspense
            fallback={
              <div className="flex h-screen w-full items-center justify-center">
                <div className="text-lg font-bold text-gray-500">Loading...</div>
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Navigate to="/home" />} />
              <Route path="/home" element={<Home />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/faq/:faqKey" element={<Faq />} />
              <Route path="/activate/:activateKey" element={<Home />} />
              <Route path="/JoinService" element={<JoinServiceGate />} />

              <Route
                path="/insurancehistory"
                element={
                  <ProtectedRoute>
                    <InsuranceHistory />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/insuranceapply"
                element={
                  <ProtectedRoute>
                    <InsuranceApply />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/insuranceterm"
                element={
                  <ProtectedRoute>
                    <InsuranceTerm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/info"
                element={
                  <ProtectedRoute>
                    <Info />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/info/edit"
                element={
                  <ProtectedRoute>
                    <InfoEdit />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dispatchterm"
                element={
                  <ProtectedRoute>
                    <DispatchTerm />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Suspense>
        </ToastProvider>
      </GlobalAlertProvider>
    </Router>
  );
}

export default App;
